import { View } from 'components/View'
import {
  STYLES_COLOR,
  STYLES_PADDING
} from 'modules/styles/constants/index.cjs'
import React from 'react'

export default function PaymentRow ({
  isSelected,
  onClick,
  children,
  ...rest
}) {
  return (
    <View
      onClick={onClick}
      style={{
        display: 'flex',
        alignItems: 'center',
        height: '2.77em',
        cursor: 'pointer',
        boxSizing: 'border-box',
        padding: STYLES_PADDING.SMALL,
        backgroundColor: STYLES_COLOR.GREY_LIGHT,
        borderRadius: '0.27em',
        border: isSelected
          ? `0.055em solid ${STYLES_COLOR.BLACK_LIGHT}`
          : `0.055em solid ${STYLES_COLOR.GREY_MEDIUM}`,
        opacity: isSelected
          ? '1'
          : '0.8'
      }}
      {...rest}
    >
      {children}
    </View>
  )
}
